"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = __importStar(require("rn-css"));
const base_ui_text_heading_1 = require("@unboared/base-ui.text.heading");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const BORDER_RADIUS = (0, base_ui_responsive_sizes_1.normalize)(20);
const HORIZONTAL_PADDING = (0, base_ui_responsive_sizes_1.normalize)(15);
const VERTICAL_PADDING = (0, base_ui_responsive_sizes_1.normalize)(25);
const StyledModal = rn_css_1.default.View `
  width : ${props => props.width};
  height : ${props => props.height};
  background-color : ${props => props.backgroundColor};
  border-radius : ${BORDER_RADIUS};
`;
const StyledHeader = rn_css_1.default.View `
  background-color : ${props => props.backgroundColor};
  padding: ${HORIZONTAL_PADDING} ${VERTICAL_PADDING};
  align-items: ${props => props.centered ? 'center' : 'start'};
  margin-bottom : ${(0, base_ui_responsive_sizes_1.normalize)(2)};
  border-top-left-radius:  ${BORDER_RADIUS};
  border-top-right-radius: ${BORDER_RADIUS};
`;
const StyledContent = rn_css_1.default.ScrollView `
  background-color:${props => props.backgroundColor};
  padding: ${HORIZONTAL_PADDING} ${VERTICAL_PADDING};
  border-bottom-left-radius:  ${props => props.hasFooter ? 0 : BORDER_RADIUS};
  border-bottom-right-radius: ${props => props.hasFooter ? 0 : BORDER_RADIUS};

  border-top-left-radius:  ${props => props.hasHeader ? 0 : BORDER_RADIUS};
  border-top-right-radius: ${props => props.hasHeader ? 0 : BORDER_RADIUS};
`;
const StyledFooter = rn_css_1.default.View `
  background-color:${props => props.backgroundColor};
  padding: ${HORIZONTAL_PADDING} ;
  align-items: ${props => props.centered ? 'center' : 'end'};
  border-bottom-left-radius:  ${BORDER_RADIUS};
  border-bottom-right-radius: ${BORDER_RADIUS};
`;
const Modal = ({ title, children, color, height, width, button1, button2, centered }) => {
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const backgroundColor = color || currentTheme.backgroundColor;
    const contentBackgroundColor = color ? (0, base_ui_theme_colors_1.transparency)(currentTheme.mode, 0.0) : (0, base_ui_theme_colors_1.transparency)(currentTheme.mode, 0.1);
    const footerBackgroundColor = color ? (0, base_ui_theme_colors_1.transparency)(currentTheme.mode, 0.1) : (0, base_ui_theme_colors_1.transparency)(currentTheme.mode, 0.2);
    const hasFooter = (button1 || button2);
    const hasHeader = (title ? true : false);
    return (react_1.default.createElement(StyledModal, { width: width, height: height, backgroundColor: backgroundColor },
        title &&
            react_1.default.createElement(StyledHeader, { backgroundColor: contentBackgroundColor, centered: centered },
                react_1.default.createElement(base_ui_text_heading_1.Heading, { text: title, type: "h1" })),
        children &&
            react_1.default.createElement(StyledContent, { backgroundColor: contentBackgroundColor, hasFooter: hasFooter, hasHeader: hasHeader }, children),
        (hasFooter) &&
            react_1.default.createElement(StyledFooter, { backgroundColor: footerBackgroundColor, centered: centered },
                react_1.default.createElement(react_native_1.View, { style: styles.flexRow },
                    react_1.default.createElement(react_native_1.View, { style: styles.button }, button1),
                    react_1.default.createElement(react_native_1.View, { style: styles.button }, button2)))));
};
exports.Modal = Modal;
const styles = react_native_1.StyleSheet.create({
    flexRow: {
        flex: 1,
        flexDirection: 'row'
    },
    button: {
        marginHorizontal: 8,
    }
});
//# sourceMappingURL=modal.js.map